export default {
    "name": "Collection",
    "kind": "HoudiniQuery",
    "hash": "e294fc4d4e45e08f33d5530f37dae691528f65a8b7bc9f37823bff6a82ab137a",

    "raw": `query Collection($handle: String!, $country: CountryCode, $locale: LanguageCode) @inContext(country: $country, language: $locale) {
  collection(handle: $handle) {
    title
    handle
    description
    path: metafield(key: "path", namespace: "sprenger") {
      key
      value
      id
    }
    metaTitle: metafield(key: "meta_title") {
      key
      value
      id
    }
    metaDescription: metafield(key: "meta_description") {
      key
      value
      id
    }
    id
  }
}
`,

    "rootType": "QueryRoot",

    "selection": {
        "fields": {
            "collection": {
                "type": "Collection",
                "keyRaw": "collection(handle: $handle)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "handle": {
                            "type": "String",
                            "keyRaw": "handle",
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "visible": true
                        },

                        "path": {
                            "type": "Metafield",
                            "keyRaw": "path(key: \"path\", namespace: \"sprenger\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "metaTitle": {
                            "type": "Metafield",
                            "keyRaw": "metaTitle(key: \"meta_title\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "metaDescription": {
                            "type": "Metafield",
                            "keyRaw": "metaDescription(key: \"meta_description\")",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "key": {
                                        "type": "String",
                                        "keyRaw": "key",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "handle": "String",
            "country": "CountryCode",
            "locale": "LanguageCode"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=83a64da1d80f7b2879b06c5813bcd1a051387c866f94234ad62889e9900e4c0a";